var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welfare-container"},[(_vm.isPage('Welfare'))?_c('div',[_c('Carousel'),_c('Main')],1):_vm._e(),(_vm.isPage('WelfareDetail'))?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }